"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.OtherPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Other: 'Other',
});
//# sourceMappingURL=other.js.map